import type { PublicBooking } from '@/gen/cortado/v1/inquiries_pb'
import { hasUnansweredQuestionnaireItems } from '@/lib/booking-questionnaire'

/**
 * Search params for `/booking/$id/questionnaire`. `invoice_id` + `schedule_id` name the payment
 * the customer was starting when the gate intercepted them, so finishing the questionnaire can
 * resume checkout instead of dropping them back on the booking page.
 */
export type QuestionnaireGateSearch = {
  token?: string
  invoice_id?: string
  schedule_id?: string
}

export function validateQuestionnaireGateSearch(search: Record<string, unknown>): QuestionnaireGateSearch {
  return {
    token: typeof search.token === 'string' ? search.token : undefined,
    invoice_id: typeof search.invoice_id === 'string' ? search.invoice_id : undefined,
    schedule_id: typeof search.schedule_id === 'string' ? search.schedule_id : undefined,
  }
}

/**
 * True when the organization requires the questionnaire before payment and the booking still has
 * unanswered required questions. The backend enforces the same rule in CreatePublicCheckoutSession.
 */
export function questionnaireGatesPayment(
  booking: Pick<PublicBooking, 'organization' | 'questionnaire'> | null | undefined,
): boolean {
  if (!booking?.organization?.requireQuestionnaireBeforePayment) return false
  return hasUnansweredQuestionnaireItems(booking.questionnaire)
}

export type QuestionnaireGateContinuation =
  | { to: 'checkout'; invoiceId: string; scheduleId: string }
  | { to: 'booking' }

/** Where the customer goes once nothing is gating payment any more. */
export function questionnaireGateContinuation(search: QuestionnaireGateSearch): QuestionnaireGateContinuation {
  if (search.invoice_id && search.schedule_id) {
    return { to: 'checkout', invoiceId: search.invoice_id, scheduleId: search.schedule_id }
  }
  return { to: 'booking' }
}
